import { render } from "./UploadAgent.vue?vue&type=template&id=48113068&scoped=true"
import script from "./UploadAgent.vue?vue&type=script&lang=js"
export * from "./UploadAgent.vue?vue&type=script&lang=js"

import "./UploadAgent.vue?vue&type=style&index=0&id=48113068&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48113068"]])

export default __exports__